import { render, staticRenderFns } from "./my_sidebar.vue?vue&type=template&id=73655c84"
import script from "./my_sidebar.vue?vue&type=script&lang=js"
export * from "./my_sidebar.vue?vue&type=script&lang=js"
import style0 from "./my_sidebar.vue?vue&type=style&index=0&id=73655c84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports